import React, { useState, useEffect, useMemo } from "react";
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import { Card, Container, Row, Col, Button, Form, FormLabel, OverlayTrigger, Tooltip } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { ReportsAction, SuperAdminAction } from "../../Actions";
import CustomContentAlert, { tableHeightScrollBars, findBySearch, scroolToTop, utcToSpecificTimeZone } from "../helper";
import { checkRateConflicts } from "../../Actions/ValidationPassagepassActions/actions";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { getAPIResponse } from "../../Selectors/APIResponseReducer";
const history = require("../../history").default;
import RateConflictsModal from '../Modal/RateConflictsModal';

const AddRateForm = () => {
  const dispatch = useDispatch();
  const apiResponse = useSelector(getAPIResponse);
  const rateTypeList = useSelector((state) => state.ReportsDetails.passagepassRateTypeList);
  const { property } = useSelector((userState) => userState.UserProfileDetails);
  const { lots } = useSelector((state) => state.SuperAdminDetails);
  const location = useLocation();
  const { pathname } = location;
  const [isEdit, setIsEdit] = useState(false);
  const [apiCall, setApiCall] = useState(false);
  const [editData, setEditData] = useState({});
  const [schedulerForm, setSchedulerForm] = useState({
    rate_profile_id: "",
    event_name: "",
    rate_name: "",
    from_date: null,
    from_hour: "",
    to_date: null,
    to_hour: "",
    properties: [],
  });
  const [schedulerErrors, setSchedulerErrors] = useState({});
  const [showAlert, setShowAlert] = useState(false); // State for success toast visibility
  const [showErrAlert, setShowErrAlert] = useState(false); // State for error toast visibility
  const [conflictErrorMessage, setConflictErrorMessage] = useState(""); // State for conflict error message
  const [propertiesData, setPropertiesData] = useState([]); // Placeholder for properties data
  const [scheduledRates, setScheduledRates] = useState([]); // Placeholder for scheduled rates
  const rate_conflicts = useSelector(
  (state) => state.PassagepassValidationDetails.rate_conflicts
);
  const passagepassRateList = useSelector((state) => state.ReportsDetails.passagepassRateList);

useEffect(() => {
  console.log("Rate conflict state updated:", rate_conflicts);
}, [rate_conflicts]);
  useEffect(() => {
    if (location?.state) {
      setEditData(location.state);
    }
  }, [location?.state]);
  const [form, setForm] = useState({
  display_name: "",
  rate_description: "",
  day: "",
  max_amount: "",
  initial_grace_period_mins: "",
  effective_start: null, // Default to null, will be set via datetime-local
  effective_stop: null,  // Default to null, will be set via datetime-local
  rate_category: "holiday", // Default to holiday, can be changed
  rate_type: "",
  isSetMaxTime: 0,
  isSetWindowMaxTime: 0,
  isSetDurationMaxtime: 0,
  entry_window_start_hour: "", // Time-only field
  entry_window_stop_hour: "",  // Time-only field
  incremental_cost: "",
  incremental_duration: "",
});
  const validateScheduler = () => {
    const errors = {};
    if (!schedulerForm.rate_profile_id) errors.rate_profile_id = "Rate Profile is required";
    if (!schedulerForm.from_date) errors.from_date = "From Date is required";
    if (!schedulerForm.from_hour) errors.from_hour = "From Hour is required";
    if (!schedulerForm.to_date) errors.to_date = "To Date is required";
    if (!schedulerForm.to_hour) errors.to_hour = "To Hour is required";
    if (!schedulerForm.properties.length) errors.properties = "At least one property is required";
    setSchedulerErrors(errors);
    return Object.keys(errors).length === 0;
  };
  // Helper function to generate time options (HH:MM format) at specified intervals
  const generateTimeOptions = (intervalMinutes = 15) => {
    const options = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += intervalMinutes) {
        const time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        options.push(time);
      }
    }
    options.push("23:59");
    return options;
  };

  // Continue with your existing optionList and other code..
  const [errors, setErrors] = useState({});
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedRadioOption, setSelectedRadioOption] = useState("definiteTime");
  const optionList = [
    { value: "0", label: "Sunday" },
    { value: "1", label: "Monday" },
    { value: "2", label: "Tuesday" },
    { value: "3", label: "Wednesday" },
    { value: "4", label: "Thursday" },
    { value: "5", label: "Friday" },
    { value: "6", label: "Saturday" },
  ];
  const [definiteDay, setDefiniteDay] = useState("0");
  const [definiteTime, setDefiniteTime] = useState("");
  const [durationDays, setDurationDays] = useState(0);
  const [durationHours, setDurationHours] = useState(0);
  const [durationMinutes, setDurationMinutes] = useState(0);
  const [isLoadingLots, setIsLoadingLots] = useState(true);
  const [conflictLoading, setConflictLoading] = useState(false);
  const [rateConflictModal, setRateConflictModal] = useState(false);
  const conflictDetails = useMemo(() => ({
    title: "Rate Conflicts Detected",
    message: conflictErrorMessage || rate_conflicts?.message || "Selected dates or days conflict with an existing rate."
  }), [conflictErrorMessage, rate_conflicts?.message]);
  //const [currentMonth, setCurrentMonth] = useState(moment().month());
  const daysOptions = [
    { value: "0", label: "Same Day" },
    { value: "1", label: "+1 Day" },
    { value: "2", label: "+2 Days" },
    { value: "3", label: "+3 Days" },
    { value: "4", label: "+4 Days" },
    { value: "5", label: "+5 Days" },
    { value: "6", label: "+6 Days" },
    { value: "7", label: "+7 Days" },
  ];

  useEffect(() => {
    dispatch(ReportsAction.getPassagePassRateType());
    const data = location?.state;
  }, []);

  useEffect(() => {
    dispatch(SuperAdminAction.setDomainHeader(property?.property_name, property?.domain));
    if (pathname === "/edit-parking-rate") {
      setIsEdit(true);
      dispatch({
        type: "CHECK_RATE_CONFLICTS",
        payload: {
          success: 1,
          conflict: false,
          conflicts: [],
          message: ""
        }
      });
      const data = location?.state;
      if (data.day) {
        const selectedValues = data.day?.split(","); // e.g., ["1", "2"]
        const selected = optionList.filter((option) => selectedValues?.includes(option.value));
        setSelectedOptions(selected);
      }

      setForm({
        display_name: data.display_name || "",
        rate_description: data.rate_description || "",
        rate_type: String(data.rate_type_id || ""),
        max_amount: String(data.max_amount || ""),
        initial_grace_period_mins: data.initial_grace_period_mins || "",
        rate_category: data.day ? "regular" : "holiday",
      });
      const initialMins = data.initial_grace_period_mins ?? 0; // null/undefined → 0
      const subsequentMins = data.subsequent_grace_period_mins ?? 0; // null/undefined → 0
      // Parse subsequent value, default to 0 if missing/null/empty
      // Split mode is active ONLY if subsequent > 0
      const shouldSplit = subsequentMins > 0;
      setForm(prev => ({
        ...prev,
        splitGracePeriod: shouldSplit,
        initial_grace_period_mins: initialMins,
        subsequent_grace_period_mins: shouldSplit ? subsequentMins : initialMins  // fallback for UI
      }));
      if (data.rate_expires) {
        if (data.rate_expires?.includes("P")) {
          setSelectedRadioOption("duration");
          const durationMatch = data.rate_expires?.match(/P(\d+)DT(\d+)H(\d+)M/) || "";
          console.log("durationMatch::::", durationMatch);
          if (durationMatch) {
            setDurationDays(durationMatch?.[1]);
            setDurationHours(durationMatch?.[2]);
            setDurationMinutes(durationMatch?.[3]);
          }
        } else {
          setSelectedRadioOption("definiteTime");
          setDefiniteDay(data.rate_expires?.split("DT")[0] || "Same Day");
          setDefiniteTime(convertTimeStringToDate(data.rate_expires?.split("DT")[1]));
        }
      }

      if (data?.formatted_effective_start && moment(data?.formatted_effective_start).isValid()) {
        setForm((prevForm) => ({
          ...prevForm,
          effective_start: new Date(data.formatted_effective_start),
        }));
      }
      if (data?.formatted_effective_stop && moment(data?.formatted_effective_stop).isValid()) {
        const effectiveStopTime = moment(data.formatted_effective_stop).format("HH:mm:ss");
        const isSetTime = effectiveStopTime === "23:59:59";
        setForm((prevForm) => ({
          ...prevForm,
          effective_stop: new Date(data.formatted_effective_stop),
          isSetMaxTime: isSetTime,
        }));
      }

      if (data?.entry_window_start && data?.entry_window_stop) {
        const startMoment = moment(data.entry_window_start, ["HH:mm:ss", "h:mm A"]);
        const stopMoment = moment(data.entry_window_stop, ["HH:mm:ss", "h:mm A"]);

        if (startMoment.isValid() && stopMoment.isValid()) {
          setForm((prevForm) => ({
            ...prevForm,
            entry_window_start_hour: startMoment.format("HH:mm:ss"),
            entry_window_stop_hour: stopMoment.format("HH:mm:ss"),
          }));
        }
      }
    }

    if (!isEdit && schedulerForm.properties.length && !isLoadingLots) {
      setSelectedOptions([]); // clear days on new lot selection
      setForm((prev) => ({ ...prev, day: "" }));
      dispatch(ReportsAction.GetPassagePassRate({
        lot_ids: schedulerForm.properties,
        property_id: property.id,
        exports: false
      }));
    }
  }, [pathname, schedulerForm.properties, isLoadingLots, dispatch, property.id]);
  useEffect(() => {
    if (!isEdit) return;
    if (form.rate_category !== "regular") return;

    const lotIds = (schedulerForm.properties && schedulerForm.properties.length)
      ? schedulerForm.properties
      : (editData?.lot_ids || []);

    if (!lotIds.length) return;
    if (!selectedOptions || selectedOptions.length === 0) return;

    const selectedDays = selectedOptions.map(o => o.value).join(",");

    setConflictLoading(true);
    dispatch(checkRateConflicts({
      property_id: property?.id,
      lot_ids: lotIds,
      days: selectedDays,
      rate_category: "regular",
      ignore_id: editData?.id,
      entry_window_start: form.entry_window_start_hour || "00:00:00",
      entry_window_stop: form.entry_window_stop_hour || "23:59:59",
    })).finally(() => setConflictLoading(false));

  }, [
    isEdit,
    form.rate_category,
    schedulerForm.properties,
    editData?.lot_ids,
    editData?.id,
    selectedOptions,
    property?.id,
    dispatch
  ]);

  const convertTimeStringToDate = (timeString) => {
    if (!timeString || typeof timeString !== "string") {
      return null;
    }

    const parts = timeString.split(":").map(Number);
    const date = new Date();

    if (parts.length >= 1) {
      date.setHours(parts[0]);
    }
    if (parts.length >= 2) {
      date.setMinutes(parts[1]);
    }
    if (parts.length >= 3) {
      date.setSeconds(parts[2]);
    }
    return date;
  };

  const formatFirstOption = () => {
    return definiteDay ? `${definiteDay}DT${moment(definiteTime).format("HH:mm:ss")}` : moment(definiteTime).format("HH:mm:ss");
  };

  const formatSecondOption = () => {
    return `P${durationDays}DT${durationHours}H${durationMinutes}M`;
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const handleMaxTime = () => {
    if (!form.isSetMaxTime) {
      let endDate = form.effective_stop ? new Date(form.effective_stop) : new Date();
      endDate = moment(endDate).set({ hour: 23, minute: 59, second: 59 });
      setForm((prevForm) => ({ ...prevForm, effective_stop: new Date(endDate) }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        effective_stop: "",
      }));
    }
    setForm((prevForm) => ({ ...prevForm, isSetMaxTime: !form.isSetMaxTime }));
  };
  const handleWindowMaxTime = () => {
    if (!form.isSetWindowMaxTime) {
      const endDate = moment(new Date()).set({ hour: 23, minute: 59, second: 59 });
      setForm((prevForm) => ({ ...prevForm, entry_window_stop: new Date(endDate) }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        entry_window_stop: "",
      }));
    } else {
      setForm((prevForm) => ({ ...prevForm, entry_window_stop: null }));
    }
    setForm((prevForm) => ({ ...prevForm, isSetWindowMaxTime: !form.isSetWindowMaxTime }));
  };
  const normalizeDuration = (days, hours, minutes) => {
  let totalMinutes = 
    parseInt(days || 0) * 24 * 60 + 
    parseInt(hours || 0) * 60 + 
    parseInt(minutes || 0);
  
  const normalizedDays = Math.floor(totalMinutes / (24 * 60));
  totalMinutes %= (24 * 60);
  const normalizedHours = Math.floor(totalMinutes / 60);
  const normalizedMinutes = totalMinutes % 60;
  
  return {
    days: normalizedDays,
    hours: normalizedHours,
    minutes: normalizedMinutes
  };
};
  const handleDurationMaxTime = () => {
  if (!form.isSetDurationMaxtime) {
    const endDate = moment(new Date()).set({ hour: 23, minute: 59, second: 59 });
    setDefiniteTime(new Date(endDate));
    setErrors(prev => ({ ...prev, definite_time: "" }));
  } else {
    setDefiniteTime(null);
  }
  setForm((prevForm) => ({ ...prevForm, isSetDurationMaxtime: !form.isSetDurationMaxtime }));
};

 const validate = () => {
  let errors1 = { ...errors }; // Keep existing errors
  const requiredFields = [
    "display_name",
    "rate_type",
    "rate_description",
    "max_amount",
    "entry_window_start_hour",
    "entry_window_stop_hour",
  ];

  // Check required fields
  requiredFields.forEach((field) => {
    if (!form[field]) {
      errors1[field] = `${capitalizeFirstLetter(field.replace(/_/g, " "))} is required`;
    }
  });

  // Validate effective start and stop for holiday rates
  if (form.rate_category === "holiday") {
    if (!form.effective_start) {
      errors1.effective_start = "Effective Start is required";
    }
    if (!form.effective_stop) {
      errors1.effective_stop = "Effective Stop is required";
     } else if (form.effective_start && form.effective_stop) {
       const start = moment(form.effective_start);
       const stop = moment(form.effective_stop);

       console.log('Validation check:', {
         start: start.format('YYYY-MM-DD HH:mm:ss'),
         stop: stop.format('YYYY-MM-DD HH:mm:ss'),
         startIsBefore: start.isBefore(stop)
       });

       if (!start.isBefore(stop)) {
         errors1.effective_stop = "Effective Stop must be after Effective Start";
       }
     }
   }

  // Validate day selection for regular rates
  if (form.rate_category === "regular" && !selectedOptions.length) {
    errors1.day = "Day(s) of week is required";
  }

  // Validate expiry options
  if (selectedRadioOption === "definiteTime" && !definiteTime) {
    errors1.definite_time = "Definite time is required";
  } else if (selectedRadioOption === "duration" && !durationDays && !durationHours && !durationMinutes) {
    errors1.duration = "Duration is required";
  }

  // Validate entry window times
  if (form.entry_window_start_hour && form.entry_window_stop_hour) {
    const start = moment(form.entry_window_start_hour, "HH:mm:ss");
    const stop = moment(form.entry_window_stop_hour, "HH:mm:ss");
    if (start.isSame(stop) || start.isAfter(stop)) {
      errors1.entry_window_stop_hour = "Active Stop Time must be after Active Start Time";
    }
  }

  // Check for schedule overlaps
  let hasOverlap = false;
  if (passagepassRateList?.data?.length) {
    const newIsHoliday = form.rate_category === "holiday";
    const newDays = newIsHoliday ? [] : selectedOptions.map(o => parseInt(o.value));
    const newStart = newIsHoliday ? moment(form.effective_start).startOf('day') : null;
    const newEnd = newIsHoliday ? moment(form.effective_stop).endOf('day') : null;
    console.log('Debug: Checking overlaps for', passagepassRateList.data.length, 'existing rates');
    for (const existing of passagepassRateList.data) {
      if (isEdit && existing.id === editData.id) continue;
      // Infer holiday: blank/empty day + dates present (matches backend/DB pattern)
      const existingIsHoliday = (!existing.day || existing.day === '' || existing.day === ',') && existing.formatted_effective_start && existing.formatted_effective_stop;
      const existingDays = existingIsHoliday ? [] : (existing.day ? existing.day.split(',').map(Number) : []);
      const existingStart = existingIsHoliday && existing.formatted_effective_start
        ? moment(existing.formatted_effective_start).startOf('day')
        : null;
      const existingEnd = existingIsHoliday && existing.formatted_effective_stop
        ? moment(existing.formatted_effective_stop).endOf('day')
        : null;

      // Skip records with invalid datetimes
      if (existingIsHoliday && (!existingStart?.isValid() || !existingEnd?.isValid())) {
        console.warn("Skipping rate with invalid datetime:", existing);
        continue;
      }

      if (newIsHoliday && existingIsHoliday) {
        // Holiday-Holiday: range overlap
        if (newStart.isSameOrBefore(existingEnd) && newEnd.isSameOrAfter(existingStart)) {
          hasOverlap = true;
          console.log('Client-side overlap detected: Holiday-Holiday', { newStart, newEnd, existingStart, existingEnd });
          break;
        }
      } else if (newIsHoliday && !existingIsHoliday) {
        // Holiday-Regular: check if any date in new range matches existing days
        let current = newStart.clone();
        while (current.isSameOrBefore(newEnd)) {
          const dow = current.weekday(); // 0=Sun ... 6=Sat
          if (existingDays.includes(dow)) {
            hasOverlap = true;
            console.log('Client-side overlap detected: Holiday-Regular on day', dow);
            break;
          }
          current.add(1, 'days');
        }
      } else if (!newIsHoliday && existingIsHoliday) {
        // Regular-Holiday: check if any date in existing range matches new days
        let current = existingStart.clone();
        while (current.isSameOrBefore(existingEnd)) {
          const dow = current.weekday();
          if (newDays.includes(dow)) {
            hasOverlap = true;
            console.log('Client-side overlap detected: Regular-Holiday on day', dow);
            break;
          }
          current.add(1, 'days');
        }
      } else if (!newIsHoliday && !existingIsHoliday) {
        // Regular-Regular: day overlap
        if (newDays.some(d => existingDays.includes(d))) {
          hasOverlap = true;
          console.log('Client-side overlap detected: Regular-Regular days', { newDays, existingDays });
          break;
        }
      }
      if (hasOverlap) break;
    }
    console.log('Client-side hasOverlap result:', hasOverlap);
  }

  if (form.incremental_enabled) {
     if (!form.incremental_cost) {
       errors1.incremental_cost = "Incremental cost is required";
     }
     if (!form.incremental_duration) {
       errors1.incremental_duration = "Incremental duration is required";
     } else if (
       Number.isNaN(Number(form.incremental_duration)) ||
       Number(form.incremental_duration) <= 0
     ) {
       errors1.incremental_duration =
         "Incremental duration must be a positive number";
     }
   }
  errors1 = Object.fromEntries(Object.entries(errors1).filter(([key, value]) => value));
  setErrors(errors1);
  return { isValid: Object.keys(errors1).length === 0, hasOverlap, errors: errors1 };
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    const isValidNumber = (/^\d+(\.\d{0,2})?$/.test(value) && parseFloat(value) > 0) || value === "";

    if (name === "max_amount") {
      if (isValidNumber) {
        setForm((prevForm) => ({ ...prevForm, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Amount must be a positive number greater than 0 with up to two decimal places",
        }));
      }
    } else if (name.endsWith("_hour")) {
      if (/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/.test(value)) {
        setForm((prevForm) => ({ ...prevForm, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          // Updated error message to be more accurate
          [name]: "Please select a valid time (15-min intervals or HH:mm:ss format)",
        }));
      }
    } else {
      setForm((prevForm) => ({ ...prevForm, [name]: value }));
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };

  const handleDateChange = (date, name) => {
    let newMoment = moment(date);
    let updatedStart = form.effective_start;
    let updatedStop = form.effective_stop;

    if (name.includes("effective")) {
      if (name === "effective_start") {
        if (form.entry_window_start_hour) {
          const [h, m] = form.entry_window_start_hour.split(":").map(Number);
          newMoment = newMoment.set({ hour: h, minute: m, second: 0 });
        } else {
          newMoment = newMoment.startOf("day");
        }

        updatedStart = newMoment.toDate();

        setForm(prev => ({
          ...prev,
          effective_start: updatedStart,
        }));
      }

      if (name === "effective_stop") {
        if (form.isSetMaxTime) {
          newMoment = newMoment.set({ hour: 23, minute: 59, second: 59 });
        } else if (form.entry_window_stop_hour) {
          const [h, m] = form.entry_window_stop_hour.split(":");
          newMoment = newMoment.set({ hour: +h, minute: +m, second: 0 });
        } else {
          newMoment = newMoment.startOf("day");
        }

        updatedStop = newMoment.toDate();

        setForm(prev => ({
          ...prev,
          effective_stop: updatedStop,
        }));

        if (updatedStart) {
          const start = moment(updatedStart);
          if (start.isSame(newMoment, "day") && !start.isBefore(newMoment)) {
            setErrors(prev => ({
              ...prev,
              effective_stop: "Effective stop time must be after effective start time.",
            }));
          } else {
            setErrors(prev => ({
              ...prev,
              effective_stop: "",
            }));
          }
        }
      }
    }

    setErrors(prev => ({ ...prev, [name]: "" }));

    // --- SAFE CONFLICT CHECK (after computing updatedStart/updatedStop) ---
    if (
      form.rate_category === "holiday" &&
      updatedStart &&
      updatedStop
    ) {
      const lotIds = schedulerForm.properties || editData.lot_ids || [];
      if (lotIds.length) {
        setConflictLoading(true);
        dispatch({
          type: "CHECK_RATE_CONFLICTS",
          payload: {
            success: 1,
            conflict: false,
            conflicts: [],
            message: ""
          }
        });

        // now run the real conflict check
        dispatch(
          checkRateConflicts({
            lot_ids: lotIds,
            effective_start: moment(updatedStart).format("YYYY-MM-DD HH:mm:ss"),
            effective_stop: moment(updatedStop).format("YYYY-MM-DD HH:mm:ss"),
            rate_category: "holiday",
            ignore_id: isEdit ? editData?.id : null,
            entry_window_start: form.entry_window_start_hour || "00:00:00",
            entry_window_stop: form.entry_window_stop_hour || "23:59:59",
          })
        ).finally(() => setConflictLoading(false));
      }
    }
  };

  const handleSelect = (data) => {
    setSelectedOptions(data);
    const selectedValues = data.map((option) => option.value).join(",");
    setForm((prev) => ({ ...prev, day: selectedValues }));
    setErrors((prev) => ({ ...prev, day: "" }));

    if (form.rate_category === "regular" && schedulerForm.properties.length) {
      const lotIds = (schedulerForm.properties && schedulerForm.properties.length)
        ? schedulerForm.properties
        : (editData?.lot_ids || []);
      setConflictLoading(true);
      clearTimeout(window.conflictDebounce);
      window.conflictDebounce = setTimeout(() => {
        dispatch(
          checkRateConflicts({
            property_id: property?.id,
            lot_ids: lotIds,
            days: selectedValues,
            rate_category: "regular",
            ignoreid: isEdit ? editData?.id : null,
            entry_window_start: form.entry_window_start_hour || "00:00:00",
            entry_window_stop: form.entry_window_stop_hour || "23:59:59",
          })
        ).finally(() => setConflictLoading(false));
      }, 200);
    }
  };

  const handleRateCategoryChange = (e) => {
    const { name, value } = e.target;
    if (name === "rate_category" && value === "holiday") {
      // Clear day selection when switching to holiday
      setSelectedOptions([]);
      setForm((prevState) => ({
        ...prevState,
        [name]: value,
        day: "",  // Explicitly clear form.day
      }));
      setErrors({ ...errors, day: "" });
    } else {
      setForm((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!schedulerForm.properties || schedulerForm.properties.length === 0) {
      setSchedulerErrors(prev => ({
        ...prev,
        properties: "At least one lot is required."
      }));

      setConflictErrorMessage("At least one lot is required.");
      setShowErrAlert(false);
      setTimeout(() => setShowErrAlert(true), 0);
      return;
    }
    // Check for conflicts from rate_conflicts
    // Block submit only if conflict is real (not just this record)
    const selectedDaysForConflict = selectedOptions.map(option => option.value).join(",");
    const freshConflictAction = await dispatch(checkRateConflicts({
      property_id: property?.id,
      lot_ids: schedulerForm.properties || editData?.lot_ids || [],
      days: selectedDaysForConflict,
      rate_category: form.rate_category,
      ignore_id: isEdit ? editData?.id : null,
      entry_window_start: form.entry_window_start_hour || "00:00:00",
      entry_window_stop: form.entry_window_stop_hour || "23:59:59",
    }));

    const freshConflicts = freshConflictAction?.payload ?? freshConflictAction;
    const hasConflict = !!freshConflicts?.conflict;
    const conflicts = Array.isArray(freshConflicts?.conflicts) ? freshConflicts.conflicts : [];
    const editId = isEdit ? String(editData?.id ?? "") : "";
    const nonSelfConflicts = (isEdit && editId)
      ? conflicts.filter(c => String(c?.id) !== editId)
      : conflicts;

    if (hasConflict && nonSelfConflicts.length > 0) {
      setConflictErrorMessage(freshConflicts?.message || "Selected dates or days conflict with an existing rate.");
      setRateConflictModal(true);
      return;
    }

    let result;
    if (selectedRadioOption === "definiteTime") {
      result = formatFirstOption();
    } else {
      result = formatSecondOption();
    }

    const { isValid, errors: freshErrors } = validate();
    const hasOverlap = hasConflict && nonSelfConflicts.length > 0;
    console.log("Validation result:", { isValid, hasOverlap, errors: freshErrors });
    if (!isValid || hasOverlap) {
      let errorMsg;
      if (hasOverlap) {
        errorMsg = "Schedule overlaps with existing rate (check days/dates).";
      } else {
        const errorMessages = Object.values(freshErrors)
          .filter((msg) => msg)
          .join("; ");
        errorMsg = errorMessages || "Please correct the form errors.";
      }
      setConflictErrorMessage(errorMsg);
      setShowErrAlert(false); // Force reset for re-render
      setTimeout(() => setShowErrAlert(true), 0); // Immediate show
      const errorTimeout = setTimeout(() => {
        setShowErrAlert(false);
        setConflictErrorMessage("");
      }, 5000);
      console.warn("Validation failed", freshErrors);
      return;
    }

    const selectedDays = selectedOptions.map((option) => option.value).join(",");

    // 1. Create a base data object
    const data = {
      ...form,
      rate_expires: result,
      location_id: editData.location_id || "",
      lot_ids: schedulerForm.properties || editData.lot_ids || [],
      day: form.rate_category === "regular" ? selectedDays : "",
      rate_category: form.rate_category,
      entry_window_start: form.entry_window_start_hour || "",
      entry_window_stop: form.entry_window_stop_hour || "",
      effective_start:
        form.rate_category === "holiday" && form.effective_start
          ? moment(form.effective_start).format("YYYY-MM-DD HH:mm:ss")
          : "0000-00-00 00:00:00",
      effective_stop:
        form.rate_category === "holiday" && form.effective_stop
          ? moment(form.effective_stop).format("YYYY-MM-DD HH:mm:ss")
          : "0000-00-00 00:00:00",
      exportValue: false,
    };
    // 2. Conditional Grace Period Logic
    data.initial_grace_period_mins = parseInt(form.initial_grace_period_mins) || 0;
    if (form.splitGracePeriod) {
      // If split is active, ensure subsequent is sent as an integer
      data.subsequent_grace_period_mins = parseInt(form.subsequent_grace_period_mins) || 0;
    } else {
      // If NOT split, delete the key entirely so it's not sent to the DB
      delete data.subsequent_grace_period_mins;
    }
    // 3. Clean up UI-only state before sending
    delete data.splitGracePeriod;
    console.log("Submitting data:", data);
    if (isEdit) {
      data.id = editData.id;
      dispatch(ReportsAction.UpdatePassagePassRate(data));
    } else {
      dispatch(ReportsAction.CreatePassagePassRate(data));
    }
    setApiCall(true);
  };

  useEffect(() => {
    if (apiResponse.api_response && apiCall) {
      setApiCall(false);
      if (!apiResponse.api_success_message && apiResponse.api_error_message) {
        setShowErrAlert(true); // Show toast for API error
        // Reset showErrAlert after 5 seconds to allow future toasts
        const errorTimeout = setTimeout(() => {
          setShowErrAlert(false);
          setConflictErrorMessage(""); // Clear error message as well
        }, 5000);
        return () => clearTimeout(errorTimeout); // Cleanup timeout on unmount
      } else if (apiResponse.api_success_message) {
        setShowAlert(true); // Show toast for success
        // Reset showAlert after 5 seconds to allow future toasts
        const successTimeout = setTimeout(() => {
          setShowAlert(false);
        }, 5000);
        history.push({
          pathname: "/parking-rate",
          state: { lot_ids: schedulerForm.properties || editData.lot_ids || [] },
        });
        return () => clearTimeout(successTimeout); // Cleanup timeout on unmount
      }
    }
  }, [apiResponse, schedulerForm.properties, editData.lot_ids]);
  useEffect(() => {
    const propertyId = property?.id || location?.state?.property_id || "";
    console.log("Fetching lots with propertyId:", propertyId);
    if (propertyId) {
      setIsLoadingLots(true);
      dispatch(SuperAdminAction.get_all_lots(propertyId, "", false, true))
        .then(() => {
          setIsLoadingLots(false);
          console.log("Lots fetch completed successfully");
        })
        .catch((error) => {
          console.error("Failed to fetch lots:", error);
          setIsLoadingLots(false);
          dispatch(SuperAdminAction.setLots([])); // Fallback to empty array on error
        });
    } else {
      console.error("Error: No property_id available for fetching lots.", { property, locationState: location.state });
      setIsLoadingLots(false);
      dispatch(SuperAdminAction.setLots([]));
    }
  }, [property?.id, location?.state?.property_id, dispatch]);

  useEffect(() => {
    const lotIds = schedulerForm.properties?.length
      ? schedulerForm.properties
      : editData.lot_ids || [];

    if (!lotIds.length) return;

    // For holiday/event rates
    if (form.rate_category === "holiday" && form.effective_start && form.effective_stop) {
      dispatch(
        checkRateConflicts({
          property_id: property?.id,
          lot_ids: lotIds,
          effective_start: moment(form.effective_start).format("YYYY-MM-DD HH:mm:ss"),
          effective_stop: moment(form.effective_stop).format("YYYY-MM-DD HH:mm:ss"),
          rate_category: "holiday",
          ignoreid: isEdit ? editData?.id : null,
          entry_window_start: form.entry_window_start_hour || "00:00:00",
          entry_window_stop: form.entry_window_stop_hour || "23:59:59",
        })
      );
    }

    // For regular rates - only check when user has selected days
    if (form.rate_category === "regular" && lotIds.length) {
      const selectedDays = (selectedOptions || []).map(o => o.value).join(",");
      if (!selectedDays) return;

      dispatch(
        checkRateConflicts({
          property_id: property?.id,
          lot_ids: lotIds,
          days: selectedDays,
          rate_category: "regular",
          ignore_id: isEdit ? editData?.id : null,
          entry_window_start: form.entry_window_start_hour || "00:00:00",
          entry_window_stop: form.entry_window_stop_hour || "23:59:59",
        })
      );
    }

  }, [
    schedulerForm.properties,     // fire when lots change
    form.effective_start,         // fire when date range changes
    form.effective_stop,
    form.rate_category,           // fire when rate type switches
    editData.lot_ids,
    isEdit,
    editData?.id,
    property?.id,
    dispatch,
  ]);
  // Force the edited lot to be selected at the state level
  useEffect(() => {
    if (!isEdit) return;
    if (!editData?.lot_id) return;
    if (isLoadingLots) return;

    setSchedulerForm(prev => ({
      ...prev,
      properties: [String(editData.lot_id)]   // hard-set selected lot
    }));
  }, [isEdit, editData?.lot_id, isLoadingLots]);

  /*const getFilteredOptionList = () => {
    if (form.rate_category !== "regular" || !schedulerForm.properties.length) return optionList;

    if (!rate_conflicts || rate_conflicts.loading) return optionList;

    const conflictingDays = new Set();
    rate_conflicts?.conflicts?.forEach(conflict => {
      if (isEdit && conflict.id === editData.id) return;

      if (conflict.day && conflict.day) {
        conflict.day
          .split(",")
          .map(d => d.trim())
          .filter(Boolean)
          .forEach(day => conflictingDays.add(day));
      }
    });

    // Fallback: also check local list if Redux conflict data empty
    if (!conflictingDays.size && passagepassRateList?.data?.length) {
      const newDays = selectedOptions.map(o => parseInt(o.value));
      passagepassRateList.data.forEach(existing => {
        if (isEdit && existing.id === editData.id) return;

        const existingIsHoliday = !existing.day || existing.day === "" ||
          (existing.day === "," && existing.formatted_effective_start && existing.formatted_effective_stop);
        if (!existingIsHoliday && existing.day) {
          const existingDays = existing.day.split(",").map(Number);
          if (newDays.some(d => existingDays.includes(d))) {
            existingDays.forEach(day => conflictingDays.add(String(day)));
          }
        }
      });
    }

    return optionList.filter(option => !conflictingDays.has(option.value));
  };*/
  //const filteredOptions = useMemo(() => getFilteredOptionList(), [rate_conflicts, schedulerForm.properties, form.rate_category]);
  // Disable (grey out) conflicting dates for holiday/event rates
    const isDateDisabled = (date) => {
     if (form.rate_category !== "holiday" || !rate_conflicts?.conflicts?.length) return false;
    console.log('🔍 isDateDisabled called:', {
      date: moment(date).format('YYYY-MM-DD'),
      rate_category: form.rate_category,
      has_conflicts: !!rate_conflicts?.conflicts?.length,
      conflicts: rate_conflicts?.conflicts
    });
    if (form.rate_category !== "holiday" || !rate_conflicts?.conflicts?.length) return false;

    // Normalize current date to midnight
    const current = moment(date).startOf("day");

    // Loop through conflicts and block days within their start/stop range
    return rate_conflicts.conflicts.some(conf => {
      const start = moment(conf.effective_start).startOf("day");
      const stop = moment(conf.effective_stop).endOf("day");
      return current.isBetween(start, stop, null, "[]"); // inclusive
    });
  };

  const handleReset = () => {
    setForm({
      display_name: "",
      rate_description: "",
      day: "",
      max_amount: "",
      initial_grace_period_mins: "",
      effective_start: null,
      effective_stop: null,
      rate_category: "holiday",
      rate_type: "",
      isSetMaxTime: 0,
      isSetWindowMaxTime: 0,
      isSetDurationMaxtime: 0,
      entry_window_start_hour: "",
      entry_window_stop_hour: "",
      incremental_cost: "",
      incremental_duration: "",
    });

    setSelectedOptions([]);
    setSelectedRadioOption("definiteTime");
    setDefiniteDay("0");
    setDefiniteTime("");
    setDurationDays(0);
    setDurationHours(0);
    setDurationMinutes(0);
    setErrors({});
    setSchedulerErrors({});

    // keep selected lots
  };
const holidayHasConflict = useMemo(() => {
  const isHoliday = form.rate_category === "holiday";
  const hasDates = !!form.effective_start && !!form.effective_stop;
  const hasConflict = !!rate_conflicts?.conflict;
  return isHoliday && hasDates && hasConflict;
}, [form.rate_category, form.effective_start, form.effective_stop, rate_conflicts?.conflict]);


  return (
    <div>
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <Card.Header>
                <Card.Title as="h4">{isEdit ? "Update" : "Add"} Parking Rate</Card.Title>
                <p className="card-category">Fill out the below form to {isEdit ? "update" : "add"} a parking rate.</p>
              </Card.Header>
              <Card.Body className="pos-rel-overflow-hide">
                {/* Red Blurb for Regular Rates */}
                {form.rate_category === "regular" && (
                  <div
                    className="alert alert-danger"
                    style={{
                      backgroundColor: '#f8d7da',
                      color: '#721c24',
                      borderColor: '#f5c6cb',
                      marginBottom: '20px',
                      fontWeight: 'bold'
                    }}
                  >
                    Regular Rates will go into effect immediately on days selected below.
                  </div>
                )}
                {/*Selected Lots */}
                <Row className="mb-3">
                  <Col md="8">
                    <Form.Group controlId="lots-select">
                      <div className="d-flex align-items-center justify-content-between mb-1">
                        <Form.Label className="mb-0">
                          Lots<span className="asterisk">*</span>
                        </Form.Label>

                        <label className="fancy-checkbox mb-0">
                          <input
                            type="checkbox"
                            id="select-all-lots"
                            disabled={!lots?.length || isEdit}
                            checked={!!lots?.length && schedulerForm.properties.length === lots.length}
                            ref={(el) => {
                              if (el) {
                                el.indeterminate =
                                  schedulerForm.properties.length > 0 &&
                                  schedulerForm.properties.length < (lots?.length || 0);
                              }
                            }}
                            onChange={(e) => {
                              if (isEdit) return; // Block on edit
                              const checked = e.target.checked;
                              const allIds = checked ? lots.map(l => String(l.id)) : [];

                              setSchedulerForm(prev => ({
                                ...prev,
                                properties: allIds
                              }));
                              setSchedulerErrors(prev => ({
                                ...prev,
                                properties: allIds.length === 0 ? "At least one lot is required" : ""
                              }));

                              // Trigger conflict check for regular rates
                              if (form.rate_category === "regular" && allIds.length > 0) {
                                const allDays = "0,1,2,3,4,5,6";
                                dispatch(
                                  checkRateConflicts({
                                    property_id: property?.id,
                                    lot_ids: allIds,
                                    days: allDays,
                                    rate_category: "regular",
                                    entry_window_start: form.entry_window_start_hour || "00:00:00",
                                    entry_window_stop: form.entry_window_stop_hour || "23:59:59",
                                  })
                                );
                              }
                            }}
                          />
                          <span>
                            <i></i>Select all
                          </span>
                        </label>
                      </div>

                      <Select
                        isMulti
                        name="lot_ids"
                        isDisabled={isEdit || isLoadingLots}
                        isLoading={isLoadingLots}
                        value={lots?.map(lot => ({
                          value: lot.id,
                          label: lot.alias || lot.name || lot.id
                        })).filter(opt => schedulerForm.properties.includes(String(opt.value)))}
                        options={lots?.map(lot => ({
                          value: lot.id,
                          label: lot.alias || lot.name || lot.id
                        }))}
                        onChange={(selected) => {
                          if (isEdit) return; // Block on edit
                          const selectedIds = selected ? selected.map(opt => String(opt.value)) : [];
                          setSchedulerForm(prev => ({ ...prev, properties: selectedIds }));
                          setSchedulerErrors(prev => ({
                            ...prev,
                            properties: selectedIds.length === 0 ? "At least one lot is required" : ""
                          }));

                          //Trigger conflict check immediately when lots are selected
                          if (selectedIds.length > 0) {
                            // For holiday rates - check dates if they exist
                            if (form.rate_category === "holiday" && form.effective_start && form.effective_stop) {
                              setConflictLoading(true);
                              dispatch(
                                checkRateConflicts({
                                  property_id: property?.id,
                                  lot_ids: selectedIds,
                                  effective_start: moment(form.effective_start).format("YYYY-MM-DD HH:mm:ss"),
                                  effective_stop: moment(form.effective_stop).format("YYYY-MM-DD HH:mm:ss"),
                                  rate_category: "holiday",
                                  ignoreid: isEdit ? editData?.id : null
                                })
                              ).finally(() => setConflictLoading(false));
                            }
                          }
                        }}
                        classNamePrefix="react-select"
                        placeholder={isLoadingLots ? "Loading lots..." : "Select lot(s)..."}
                        isClearable={!isEdit}
                        closeMenuOnSelect={false}
                        blurInputOnSelect={false}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 })
                        }}
                      />
                      <div className="help-block" style={{ minHeight: "18px" }}>{schedulerErrors.properties || ""}</div>
                    </Form.Group>
                  </Col>
                </Row>
                <Form>
                  <Row>
                    <Col md={6}>
                      <Form.Group controlId="rateType">
                        <Form.Label>
                          Rate Type
                          <span className="asterisk">*</span>
                        </Form.Label>
                        <Form.Control as="select" name="rate_type" value={form.rate_type} onChange={handleRateCategoryChange}>
                          <option value="">--Select Rate Type--</option>
                           {(rateTypeList ?? [])
                          .filter((i) => i.id === 12 || i.id === 13)
                          .map((i) => (
                            <option key={i.id} value={i.id}>
                              {i.label}
                            </option>
                          ))}
                        </Form.Control>
                        <div className="help-block" style={{ minHeight: "18px" }}>{errors.rate_type || ""}</div>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>
                          Rate Category
                          <span className="asterisk">*</span>
                        </Form.Label>
                        <Form.Control
                          disabled={isEdit}
                          as="select"
                          name="rate_category"
                          value={form.rate_category}
                          onChange={handleRateCategoryChange}
                        >
                          <option value="holiday">Holiday/Event Rate</option>
                          <option value="regular">Regular Rate</option>
                        </Form.Control>
                        <div className="help-block" style={{ minHeight: "18px" }}>{errors.rate_category || ""}</div>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>
                          Rate Title
                          <span className="asterisk">*</span>
                        </Form.Label>
                        <Form.Control type="text" name="display_name" value={form.display_name} onChange={handleChange} />
                        <div className="help-block" style={{ minHeight: "18px" }}>{errors.display_name || ""}</div>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>
                          Description<span className="asterisk">*</span>
                        </Form.Label>
                        <Form.Control type="text" name="rate_description" value={form.rate_description} onChange={handleChange} />
                        <div className="help-block" style={{ minHeight: "18px" }}>{errors.rate_description || ""}</div>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>
                          Amount
                          <span className="asterisk">*</span>
                        </Form.Label>
                        <Form.Control type="text" name="max_amount" value={form.max_amount} min={1} onChange={handleChange} />
                        <div className="help-block" style={{ minHeight: "18px" }}>{errors.max_amount || ""} </div>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <Form.Label className="mb-0">
                            {form.splitGracePeriod ? "Initial Grace Period (Mins)" : "Grace Period (Minutes)"}
                          </Form.Label>
                          {/* New Manual Checkbox to match Max Time style */}
                          <label className="d-flex align-items-center mb-0" style={{ fontSize: '12px', cursor: 'pointer', fontWeight: 'bold' }}>
                            <input
                              type="checkbox"
                              className="mr-1"
                              checked={form.splitGracePeriod || false}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                setForm(prev => ({
                                  ...prev,
                                  splitGracePeriod: isChecked,
                                  // Sync subsequent back to initial if turning split off
                                  subsequent_grace_period_mins: isChecked ? prev.subsequent_grace_period_mins : prev.initial_grace_period_mins
                                }));
                              }}
                            />
                            <span>Secondary Grace</span>
                          </label>
                        </div>
                        <Form.Control
                          type="number"
                          name="initial_grace_period_mins"
                          value={form.initial_grace_period_mins || ""}
                          min={0}
                          onChange={(e) => {
                            const val = e.target.value;
                            handleChange(e);
                            // If not split, automatically sync the subsequent value
                            if (!form.splitGracePeriod) {
                              setForm(prev => ({ ...prev, subsequent_grace_period_mins: val }));
                            }
                          }}
                          placeholder="Enter minutes"
                        />
                        <div className="help-block" style={{ minHeight: "18px" }}>{errors.initial_grace_period_mins || ""}</div>
                      </Form.Group>
                    </Col>
                    {/* Conditional Subsequent Grace Period Field */}
                    {form.splitGracePeriod && (
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            Subsequent Grace Period (Mins)
                          </Form.Label>
                          <Form.Control
                            type="number"
                            name="subsequent_grace_period_mins"
                            value={form.subsequent_grace_period_mins || ""}
                            min={0}
                            onChange={handleChange}
                            placeholder="Enter minutes"
                          />
                          <div className="help-block" style={{ minHeight: "18px" }}>{errors.subsequent_grace_period_mins || ""}</div>
                        </Form.Group>
                      </Col>
                    )}
                  </Row>

                  {/* Conditional Fields Based on Rate Category */}
                  {form.rate_category === "holiday" ? (
                    <>
                      <Row className="align-items-end mt-2">
                        <Col md={6}>
                          <Form.Group controlId="effectiveStart">
                            <Form.Label>
                              Start Date<span className="asterisk">*</span>
                            </Form.Label>
                            <DatePicker
                              selected={form.effective_start ? new Date(form.effective_start) : null}
                              onChange={(date) => handleDateChange(date, "effective_start")}
                              dateFormat="yyyy-MM-dd"
                              className="form-control form-control-sm px-2 py-1 w-100"
                              wrapperClassName="d-block w-100"
                              placeholderText="Select start date"
                              minDate={new Date()}
                              maxDate={form.effective_stop || null}
                              required
                            />
                            <div
                              className="help-block text-danger"
                              style={{ minHeight: "18px" }}
                            >
                              {form.rate_category === "holiday" && holidayHasConflict
                                ? ("Active Rate exists for selected date")
                                : ""}
                            </div>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group controlId="effectiveStop">
                            <Form.Label>
                              Stop Date<span className="asterisk">*</span>
                            </Form.Label>
                            <DatePicker
                              selected={form.effective_stop ? new Date(form.effective_stop) : null}
                              onChange={(date) => handleDateChange(date, "effective_stop")}
                              dateFormat="yyyy-MM-dd"
                              className="form-control form-control-sm px-2 py-1 w-100"
                              wrapperClassName="d-block w-100"
                              placeholderText="Select stop date"
                              minDate={form.effective_start ? new Date(form.effective_start) : new Date()}
                              required
                            />
                            <div className="help-block" style={{ minHeight: "18px" }}>{errors.effective_stop || ""}</div>
                          </Form.Group>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <Row>
                      <Col md={6}>
                          <Form.Group>
                            <Form.Label>Day(s) of Week<span className="asterisk">*</span></Form.Label>
                            <Select
                              options={optionList}
                              placeholder="Select Day(s) of Week"
                              value={selectedOptions}
                              isMulti
                              onChange={handleSelect}
                            />

                            {!isEdit && (
                              <div className="help-block text-danger" style={{ minHeight: "18px" }}>
                                {(() => {
                                  if (!rate_conflicts?.conflicts?.length) return "";

                                  return "Active Rate exists for selected day";
                                })()}
                              </div>
                            )}
                            <div className="help-block" style={{ minHeight: "18px" }}>{errors.day || ""}</div>
                          </Form.Group>
                      </Col>
                    </Row>
                  )}

                  {/* NEW: Clean time pickers – looks identical to old layout */}
                  {(() => {
                    // Calculate conflicting times once
                    const conflictingTimes = new Set();
                    if (form.effective_start && form.effective_stop && rate_conflicts?.conflicts) {
                      const lotIds = schedulerForm.properties || editData.lot_ids || [];

                      for (let i = 0; i < 96; i++) {
                        const hour = Math.floor(i / 4);
                        const minute = (i % 4) * 15;
                        const timeStr = `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;

                        const slotStart = moment(form.effective_start).set({ hour, minute, second: 0 });
                        const slotEnd = slotStart.clone().add(15, "minutes");

                        const hasConflict = rate_conflicts.conflicts.some(c =>
                          lotIds.includes(c.lot_id) &&
                          slotStart.isBefore(moment(c.effective_stop)) &&
                          slotEnd.isAfter(moment(c.effective_start))
                        );

                        if (hasConflict) conflictingTimes.add(timeStr);
                      }
                    }

                    const filterTime = (date) => {
                      const timeStr = moment(date).format("HH:mm:ss");
                      return !conflictingTimes.has(timeStr);
                    };
                    // Get the latest stop time from all current conflicts (for regular rates)
                    const suggestedStartTime = useMemo(() => {
                      if (form.rate_category !== "regular" || !rate_conflicts?.conflicts?.length) return null;

                      const stops = rate_conflicts.conflicts
                        .filter(c => c.entry_window_stop)
                        .map(c => moment(c.entry_window_stop, "HH:mm:ss"));

                      if (!stops.length) return null;

                      const latest = moment.max(stops);
                      return moment(`2000-01-01`).set({
                        hour: latest.hours(),
                        minute: latest.minutes(),
                        second: 0,
                      }).add(1, "minute").toDate();
                    }, [rate_conflicts?.conflicts, form.rate_category]);

                    return (
                      <Row className="align-items-end">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="mb-1">
                              Start Time <span className="asterisk">*</span>
                            </Form.Label>
                            <DatePicker
                              selected={
                                form.entry_window_start_hour
                                  ? moment(`2000-01-01 ${form.entry_window_start_hour}`).toDate()
                                  : null
                              }
                              onChange={(date) => {
                                if (date) {
                                  const timeStr = moment(date).format("HH:mm:ss");
                                  handleChange({
                                    target: {
                                      name: "entry_window_start_hour",
                                      value: timeStr,
                                    },
                                  });

                                  // Update effective_start with the new time if date is set
                                  if (form.effective_start) {
                                    const [h, m, s] = timeStr.split(":").map(Number);
                                    const newStart = moment(form.effective_start)
                                      .set({ hour: h, minute: m, second: s });
                                    setForm((prev) => ({
                                      ...prev,
                                      effective_start: newStart.toDate(),
                                    }));
                                    setErrors((prev) => ({ ...prev, effective_start: "" }));
                                  }
                                }
                              }}
                              showTimeSelect
                              showTimeSelectOnly
                              timeIntervals={15}
                              timeCaption="Time"
                              dateFormat="h:mm aa"
                              timeFormat="h:mm aa"
                              filterTime={filterTime}
                              injectTimes={suggestedStartTime ? [suggestedStartTime] : []}
                              className="form-control"
                              placeholderText="Select start time"
                              popperPlacement="bottom-start"
                              wrapperClassName="w-100"
                            />
                            <div className="help-block" style={{ minHeight: "18px" }}>{errors.entry_window_start_hour || ""}</div>
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="mb-1">
                              Stop Time <span className="asterisk">*</span>
                            </Form.Label>
                            <DatePicker
                              selected={
                                form.entry_window_stop_hour
                                  ? moment(`2000-01-01 ${form.entry_window_stop_hour}`).toDate()
                                  : null
                              }
                              onChange={(date) => {
                                if (date) {
                                  const timeStr = moment(date).format("HH:mm:ss");
                                  handleChange({
                                    target: {
                                      name: "entry_window_stop_hour",
                                      value: timeStr,
                                    },
                                  });

                                  // Update effective_stop with the new time if date is set
                                  if (form.effective_stop) {
                                    const [h, m, s] = timeStr.split(":").map(Number);
                                    const newStop = moment(form.effective_stop)
                                      .set({ hour: h, minute: m, second: s });
                                    setForm((prev) => ({
                                      ...prev,
                                      effective_stop: newStop.toDate(),
                                    }));
                                    setErrors((prev) => ({ ...prev, effective_stop: "" }));
                                  }
                                }
                              }}
                              showTimeSelect
                              showTimeSelectOnly
                              timeIntervals={15}
                              injectTimes={generateTimeOptions().map((timeStr) => {
                                const [hours, minutes] = timeStr.split(":").map(Number);
                                return new Date(2000, 0, 1, hours, minutes);
                              })}
                              timeCaption="Time"
                              dateFormat="h:mm aa"
                              timeFormat="h:mm aa"
                              filterTime={filterTime}
                              className="form-control"
                              placeholderText="Select stop time"
                              popperPlacement="bottom-start"
                              wrapperClassName="w-100"
                            />

                            <div className="help-block" style={{ minHeight: "18px" }}>{errors.entry_window_stop_hour || ""}</div>
                          </Form.Group>
                        </Col>
                      </Row>
                    );
                  })()}
                  {/* ROW 1: Definite Time */}
                  {/* Section Header for Clarity */}
                  <Row className="mb-3">
                    <Col>
                      <label className="d-flex align-items-center text-nowrap mb-0" style={{ cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' }}>Session Validation</label>
                      <small className="text-muted">Choose when the parking rate is valid until</small>
                    </Col>
                  </Row>

                  {/* Definite Time Option */}
                  <Row className="align-items-start mb-3">
                    <Col md={3} className="pt-2">
                      <Form.Check
                        type="radio"
                        name="expiryOption"
                        id="definiteTime"
                        value="definiteTime"
                        checked={selectedRadioOption === "definiteTime"}
                        onChange={(e) => {
                          setSelectedRadioOption(e.target.value);
                          if (e.target.value === "definiteTime") {
                            setDurationDays("");
                            setDurationHours("");
                            setDurationMinutes("");
                          }
                        }}
                        label="Expires at a specific time"
                      />
                    </Col>
                    <Col md={3}>
                      <Form.Control
                        as="select"
                        value={definiteDay}
                        disabled={selectedRadioOption === "duration"}
                        onChange={(e) => {
                          setDefiniteDay(e.target.value);
                          setErrors({ ...errors, definite_time: "" });
                        }}
                      >
                        {daysOptions.map((day) => (
                          <option key={day.value} value={day.value}>
                            {day.label}
                          </option>
                        ))}
                      </Form.Control>
                    </Col>
                    <Col md={6}>
                      <div className="d-flex align-items-start">
                        <div className="flex-grow-1 mr-2">
                          <DatePicker
                            selected={definiteTime ? new Date(definiteTime) : null}
                            onChange={(date) => {
                              setDefiniteTime(date);
                              setErrors({ ...errors, definite_time: "" });
                            }}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Time"
                            dateFormat="h:mm aa"
                            timeFormat="h:mm aa"
                            disabled={selectedRadioOption === "duration" || form.isSetDurationMaxtime}
                            className="form-control"
                            placeholderText="Select Time"
                            popperPlacement="bottom-start"
                            wrapperClassName="w-100"
                          />
                          <div className="help-block" style={{ minHeight: "18px" }}>{errors.definite_time || ""}</div>
                        </div>
                        <div className="pt-2">
                          <OverlayTrigger
                            delay={{ show: 250, hide: 400 }}
                            placement={"top"}
                            overlay={<Tooltip>When checked, sets time to 23:59.</Tooltip>}
                          >
                            <label className="d-flex align-items-center text-nowrap mb-0" style={{ cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' }}>
                              <input
                                type="checkbox"
                                className="mr-1"
                                checked={form.isSetDurationMaxtime}
                                onChange={handleDurationMaxTime}
                              />
                              <span>Max Time</span>
                            </label>
                          </OverlayTrigger>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  {/* Duration Option */}
                  <Row className="align-items-center">
                    <Col md={3}>
                      <Form.Check
                        type="radio"
                        name="expiryOption"
                        value="duration"
                        checked={selectedRadioOption === "duration"}
                        onChange={(e) => {
                          setSelectedRadioOption(e.target.value);
                          if (e.target.value === "duration") {
                            setDefiniteDay("");
                            setDefiniteTime(null);
                          }
                        }}
                        label="Expires after a duration"
                      />
                    </Col>
                    <Col md={3}>
                      <Form.Label>Days</Form.Label>
                      <Form.Control
                        disabled={selectedRadioOption === "definiteTime"}
                        type="number"
                        min="0"
                        step="1"
                        value={durationDays}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Allow empty or valid positive integers only
                          if (value === "" || /^\d+$/.test(value)) {
                            setDurationDays(value);
                            setErrors({ ...errors, duration: "" });
                          }
                        }}
                        onBlur={() => {
                          // Normalize on blur
                          if (durationDays || durationHours || durationMinutes) {
                            const normalized = normalizeDuration(durationDays, durationHours, durationMinutes);
                            setDurationDays(normalized.days.toString());
                            setDurationHours(normalized.hours.toString());
                            setDurationMinutes(normalized.minutes.toString());
                          }
                        }}
                        placeholder="0"
                      />
                    </Col>
                    <Col md={3}>
                      <Form.Label>Hours</Form.Label>
                      <Form.Control
                        disabled={selectedRadioOption === "definiteTime"}
                        type="number"
                        min="0"
                        step="1"
                        value={durationHours}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "" || /^\d+$/.test(value)) {
                            setDurationHours(value);
                            setErrors({ ...errors, duration: "" });
                          }
                        }}
                        onBlur={() => {
                          if (durationDays || durationHours || durationMinutes) {
                            const normalized = normalizeDuration(durationDays, durationHours, durationMinutes);
                            setDurationDays(normalized.days.toString());
                            setDurationHours(normalized.hours.toString());
                            setDurationMinutes(normalized.minutes.toString());
                          }
                        }}
                        placeholder="0"
                      />
                    </Col>
                    <Col md={3}>
                      <Form.Label>Minutes</Form.Label>
                      <Form.Control
                        disabled={selectedRadioOption === "definiteTime"}
                        type="number"
                        min="0"
                        step="1"
                        value={durationMinutes}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "" || /^\d+$/.test(value)) {
                            setDurationMinutes(value);
                            setErrors({ ...errors, duration: "" });
                          }
                        }}
                        onBlur={() => {
                          if (durationDays || durationHours || durationMinutes) {
                            const normalized = normalizeDuration(durationDays, durationHours, durationMinutes);
                            setDurationDays(normalized.days.toString());
                            setDurationHours(normalized.hours.toString());
                            setDurationMinutes(normalized.minutes.toString());
                          }
                        }}
                        placeholder="0"
                      />
                    </Col>
                  </Row>
                   {/* Incremental pricing (optional) */}
                  <Row className="mt-2">
                    <Col md={12}>
                      <div
                        className="d-flex justify-content-between align-items-center mb-2"
                        style={{ borderTop: "1px solid #eee", borderBottom: "1px solid #eee", paddingTop: 10, paddingBottom: 10 }}
                      >
                        <div>
                          <label
                            className="mb-0"
                            style={{ fontWeight: "bold", fontSize: "13px" }}
                          >
                            Incremental Pricing
                          </label>
                          <div className="text-muted" style={{ fontSize: "11px" }}>
                            Add per-block charge after base session if needed
                          </div>
                        </div>
                        <label
                          className="d-flex align-items-center mb-0"
                          style={{ cursor: "pointer", fontSize: "12px", fontWeight: "bold" }}
                        >
                          <input
                            type="checkbox"
                            className="mr-1"
                            checked={!!form.incremental_enabled}
                            onChange={(e) =>
                              setForm((prev) => ({
                                ...prev,
                                incremental_enabled: e.target.checked,
                                // clear values when turning off
                                ...(e.target.checked
                                  ? {}
                                  : { incremental_cost: "", incremental_duration: "" }),
                              }))
                            }
                          />
                          <span>Enable Incremental</span>
                        </label>
                      </div>
                    </Col>

                    {form.incremental_enabled && (
                      <>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              Incremental Cost
                              <span className="asterisk">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="incremental_cost"
                              value={form.incremental_cost}
                              onChange={handleChange}
                              placeholder="e.g. 5.00"
                            />
                            <div className="help-block" style={{ minHeight: "18px" }}>
                              {errors.incremental_cost || ""}
                            </div>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              Incremental Duration (Minutes)
                              <span className="asterisk">*</span>
                            </Form.Label>
                            <Form.Control
                              type="number"
                              name="incremental_duration"
                              value={form.incremental_duration}
                              min={1}
                              onChange={handleChange}
                              placeholder="e.g. 30"
                            />
                            <div className="help-block" style={{ minHeight: "18px" }}>
                              {errors.incremental_duration || ""}
                            </div>
                          </Form.Group>
                        </Col>
                      </>
                    )}
                  </Row>
                  <div className="d-flex justify-content-end mt-4">
                    <Button
                      className="btn-fill"
                      type="button"
                      variant="danger"
                      onClick={() => {
                        history.push({
                          pathname: "/parking-rate",
                          state: { lot_ids: schedulerForm.properties || editData.lot_ids }
                        });
                      }}
                    >
                      Back
                    </Button>
                    <Button
                      className="btn-fill ml-2"
                      type="button"
                      variant="secondary"
                      onClick={handleReset}
                    >
                      Reset
                    </Button>
                    <Button 
                      onClick={handleSubmit} 
                      type="button" 
                      variant="primary" 
                      className="btn-blue-bg ml-2"
                    >
                      {isEdit ? "Update" : "Create"}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <>
          {showAlert && apiResponse?.api_success_message && (
            <CustomContentAlert
              delay={5000}
              message={apiResponse.api_success_message}
              className="toast-success"
            />
          )}
          {showErrAlert && (conflictErrorMessage || apiResponse?.api_error_message) && (
            <CustomContentAlert
              delay={5000}
              message={conflictErrorMessage || apiResponse.api_error_message}
              className="toast-error"
            />
          )}
          {rateConflictModal && (
            <RateConflictsModal
              showBrowserModal={rateConflictModal}
              closeModal={() => setRateConflictModal(false)}
              details={{ title: "Unable to create/edit rate", message: conflictErrorMessage }}
              handleSave={() => setRateConflictModal(false)}
              handleCancel={() => setRateConflictModal(false)}
            />
          )}
        </>
      </Container>
    </div>
  );
};

export default AddRateForm;
